'use client'

import { useActionState } from 'react'
import { handleLogin } from '../actions'
import LoginForm, { type LoginFormProps } from './LoginForm'

export type AuthFormProps = {
  /**
   * Configuration for social-login providers (Apple, Google, Facebook).
   * @see {@link LoginFormProps.socialLoginConfig}
   */
  socialLoginConfig?: LoginFormProps['socialLoginConfig']
}

export default function AuthForm({ socialLoginConfig }: AuthFormProps) {
  const [state, formAction, loginInProgress] = useActionState(handleLogin, {
    action: 'login',
  })

  return (
    <LoginForm
      state={state ?? {}}
      formAction={formAction}
      isPending={loginInProgress}
      socialLoginConfig={socialLoginConfig}
    />
  )
}
